<p-inputMask
    mask="99:99"
    placeholder="00:00"
    inputId="time-string"
    [(ngModel)]="timeString"
    (onComplete)="timeStringChanged()"
    [disabled]="disabled"
    [styleClass]="styleClass"
    [style]="style">
</p-inputMask>


